module.exports = __webpack_public_path__ + "img/4pica.5156259e.png";